import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import SmartFeedPagination from "~/dynamic-components/options/smart-feed-pagination";

export default class SmartFeedSeeAllText extends BaseOption {
  static label = "See All Text";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
  };
  static defaultValue = "See All";

  static canShow(paginationType) {
    return paginationType === SmartFeedPagination.optionValues.linkToViewAllPage.id;
  }
}
